import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Button, Drawer as MUIDrawer, IconButton } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  openButton: {
    marginLeft: 'auto',
    padding: '6px 9px',
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.light,
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
  drawer: {
    width: 420,
    maxWidth: '100%',
  },
  header: {
    padding: theme.spacing(2, 1),
    display: 'flex',
    height: '10%',
    justifyContent: 'space-between',
  },
  content: {
    height: '90%',
  },
  buttonIcon: {
    marginRight: theme.spacing(1),
  },
}));

const Drawer = ({ children, btnContent, infoBtn }) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();
  return (
    <div>
      {infoBtn ? (
        <IconButton
          component="span"
          aria-label="Open Tooltip"
          style={{ color: '#546E7A' }}
          onClick={() => setOpen(true)}>
          <ErrorOutlineIcon />
        </IconButton>
      ) : (
        <Button
          className={classes.openButton}
          color="primary"
          onClick={() => setOpen(true)}
          size="small"
          variant="outlined">
          {btnContent}
        </Button>
      )}
      <MUIDrawer
        anchor="right"
        classes={{ paper: classes.drawer }}
        onClose={() => setOpen(false)}
        open={open}
        variant="temporary">
        <>
          <div className={classes.header}>
            <Button
              onClick={() => setOpen(false)}
              size="small"
              sx={{
                '&&': {
                  color: '#263238',
                },
                '&&:hover': {
                  backgroundColor: 'rgba(38, 50, 56, 0.04)',
                },
              }}>
              <CloseIcon className={classes.buttonIcon} />
              {t('close')}
            </Button>
          </div>
          <div className={classes.content}>{children}</div>
        </>
      </MUIDrawer>
    </div>
  );
};

Drawer.propTypes = {
  infoBtn: PropTypes.bool,
  children: PropTypes.node,
  btnContent: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
};

export default Drawer;
